import { redirect } from "react-router";
import { SignUpStepRoutes, SignUpSteps } from "../../interfaces/Navigation";
import { SUACService } from "../../services/SignUpAppConfig.service";


export async function signUpStepLoader({ request }: any) {
    const userIsVerified = SUACService.checkIfUserIsVerified();
    const hasCreatedApp = SUACService.getCmsLink();
    const url = new URL(request.url);
    const pathname = url.pathname;

    const step = (Object.keys(SignUpStepRoutes) as SignUpSteps[]).find((key) => SignUpStepRoutes[key] === pathname);
    if (!step) return null;

    let target: string | null = null;

    if (hasCreatedApp) {
        target = SignUpStepRoutes[SignUpSteps.DOWNLOAD];
    } else if (userIsVerified) {
        target = SignUpStepRoutes[SignUpSteps.DESIGN];
    } else if (step === SignUpSteps.DOWNLOAD || step === SignUpSteps.DESIGN){
        target = SignUpStepRoutes[SignUpSteps.ONBOARDING];
    } else {
        target = SignUpStepRoutes[step];
    }

    if (target === pathname) {
        return null;
    }

    return redirect(target);
}
